import type { Campaign } from "./campaign"
import type { SearchCriteriaStatus } from "./search-criteria"

export type MasterListRecordStatus = "none" | "skip" | "used"
export type ProviderBucket = "google" | "microsoft" | "other" | "unknown"
export const PROVIDER_BUCKETS: ProviderBucket[] = [
  "google",
  "microsoft",
  "other",
  "unknown",
]
export type ProviderBreakdown = Record<ProviderBucket, number>
export type MasterList = {
  _id: string
  name: string
  campaign: null | Campaign
  total: number
  available: number
  used: number
  skip: number
  providerBreakdown?: ProviderBreakdown
  searchCriteria?: {
    _id: string
    name: string
    status: string
  }
}
export type SearchCriteriaMasterList = MasterList & {
  searchCriteria?: {
    _id: string
    status: SearchCriteriaStatus
  }
}
export type CreateEditMasterListPayload = {
  orgId: string
  name?: string
  records?: {
    _id: string
    firstName?: string
    lastName?: string
    email?: string
    status?: MasterListRecordStatus
  }[]
}
export type MasterListRecord = {
  _id: string
  firstName: string
  lastName: string
  email: string
  status: "none" | "skip" | "used"
  linkedInUrl: string
  employeeCount: string
  industry: string
  providerType: ProviderBucket
  [key: string]: string
}
export type SingleMasterList = {
  _id: string
  name: string
  total: number
  records: MasterListRecord[]
}
